import { ENV } from '~/utils/env';

export const MY_POINT_URL = {
  prod: 'https://point.cashnote.kr/my-point',
  stg: 'https://point.cashnote.kr/my-point',
  dev: 'https://dev-point.cashnote.kr/my-point',
}[ENV];
